import { createPaginatedSlice } from "../../../helpers/reduxHelper";

const paginatedLight = createPaginatedSlice('paginatedLight');

export const paginatedLightActions = paginatedLight.actions
export const paginatedLightSelector = state => state.paginatedLight;
export const paginatedLightReducer = paginatedLight.reducer;
export default paginatedLightReducer

export const paginatedLightSelectors = paginatedLight.LF.selectors